import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { nextActions } from '@app/store/next';
import { lessonActions } from '../actions/lesson.actions';

@Injectable({
    providedIn: 'root',
})
export class NextLessonBridge {
    private readonly actions = inject(Actions);

    onNextFetchGetLesson$ = createEffect(() => {
        return this.actions.pipe(
            ofType(nextActions.getNextContentSuccess),
            map(({ payload }) => payload.lessonId),
            filter((lessonId) => lessonId !== null),
            map((lessonId) => lessonActions.getLesson({ id: lessonId })),
        );
    });
}
